import React from "react";
import { StyleSheet, Text, TouchableOpacity } from "react-native";
import * as Linking from "expo-linking";
import { Feather } from "@expo/vector-icons";

type Props = {
  link: string;
};

const WebsiteButton = ({ link }: Props): React.JSX.Element => {
  const handlePress = (): void => {
    Linking.openURL(link);
  };

  return (
    <TouchableOpacity style={[styles.button]} onPress={handlePress}>
      <Feather name="log-out" size={20} color="#fff" style={styles.icon} />
      <Text style={styles.text}>Website</Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#01579b",
    justifyContent: "center",
    paddingVertical: 12,
    paddingHorizontal: 16,
    borderRadius: 8,
    width: "90%",
  },
  icon: {
    marginRight: 8,
  },
  text: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
  },
});

export default WebsiteButton;
